/* Centralized session module for every SVADEZI page that needs to know who is
 * signed in. One login for the whole site: our own phone/WhatsApp OTP session
 * (see mto-otp), never Shopify's customer accounts -- Shopify cannot do phone
 * login on any plan, and Multipass is Shopify Plus only.
 *
 * Every protected page calls SvzAuth.requireSession() instead of rolling its
 * own fetch/localStorage/redirect logic. That is the whole point of this
 * file: one implementation, reused, so a fix here fixes every page at once.
 *
 * Deliberately NOT used by /pages/track. That page is reachable by its
 * emailed ?t=<access_token> link alone, with no login required -- gating it
 * here would break the CAD-ready notification links already sent to
 * customers today. Session middleware and bearer-token links are two
 * different, intentionally separate access paths.
 */
window.SvzAuth = (function () {
  var SESSION_KEY = "svz-session";

  function getToken() {
    try { return localStorage.getItem(SESSION_KEY) || ""; } catch (e) { return ""; }
  }
  function setToken(token) {
    try { localStorage.setItem(SESSION_KEY, token); } catch (e) {}
  }
  function clearToken() {
    try { localStorage.removeItem(SESSION_KEY); } catch (e) {}
  }

  function api(cfg, payload) {
    return fetch(cfg.supabaseUrl + "/functions/v1/mto-otp", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        apikey: cfg.supabaseKey,
        Authorization: "Bearer " + cfg.supabaseKey
      },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    });
  }

  // Preserves the page the customer actually wanted, so login can return
  // them to it -- "Check Session -> No Session -> OTP Login -> Continue
  // Automatically" rather than dropping them on a generic dashboard.
  function buildNextUrl(overridePath) {
    var path = overridePath || (window.location.pathname + window.location.search);
    return path;
  }

  function redirectToLogin(cfg, overridePath) {
    clearToken();
    var next = encodeURIComponent(buildNextUrl(overridePath));
    window.location.href = (cfg.loginUrl || "/pages/login") + "?next=" + next;
  }

  // The one function every protected page calls. It hides nothing itself --
  // the page's own markup/CSS controls the loading state -- it only decides
  // whether to reveal, redirect, or report a recoverable error.
  //
  // opts.onAuthenticated(session)  -- session = {identifier, channel, orders, shopify_orders}
  // opts.onError()                 -- network failure; session token itself may still be valid,
  //                                    so this must NOT redirect to login or clear the token
  function requireSession(cfg, opts) {
    opts = opts || {};
    var token = getToken();
    if (!token) { redirectToLogin(cfg); return; }

    api(cfg, { action: "session", token: token })
      .then(function (j) {
        if (!j || j.ok !== true) { redirectToLogin(cfg); return; }
        if (opts.onAuthenticated) opts.onAuthenticated(j);
      })
      .catch(function () {
        if (opts.onError) opts.onError();
      });
  }

  function logout(cfg, opts) {
    opts = opts || {};
    var token = getToken();
    api(cfg, { action: "logout", token: token })
      .catch(function () {})
      .finally(function () {
        clearToken();
        if (opts.redirect !== false) {
          window.location.href = (cfg.homeUrl || "/");
        }
      });
  }

  return {
    getToken: getToken,
    setToken: setToken,
    clearToken: clearToken,
    api: api,
    requireSession: requireSession,
    redirectToLogin: redirectToLogin,
    logout: logout
  };
})();
